export default "__VITE_ASSET__711968a8__"